<template>
  <v-app>

    <v-main>
      <router-view />
    </v-main>

  </v-app>
</template>

<script>
  import { mapGetters, mapActions }    from "vuex";

  export default {
    name: "App",

    components:{
    },

    data: () => ({

    }),

    async created(){

    },

    methods:{

    },

    computed:{
      
    },
  };
</script>
<style>

  main{
/*    background: #00c1d8 ;*/
    background: #9F0000 ;
  }

  .v-navigation-drawer__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-navigation-drawer__content::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-button:increment,.v-navigation-drawer__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-thumb{
/*    background-color: #00c1d8;*/
    background-color: #9F0000;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  html{
/*    background: #00c1d8;*/
    background: #9F0000;
  }

  .v-main__wrap{
/*    background: #00c1d8 !important;*/
    background: #9F0000 !important;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }

  .btn-login{
    background: rgb(0,26,252);
    background: linear-gradient(90deg, rgba(0,26,252,1) 0%, rgba(0,255,252,1) 100%);
  }
</style>
